// `parseFloat(x) * 100` carries binary floating-point error (e.g. `10.29 * 100` can land on
// 1028.9999999999998). Parsing the dollars and the cents as separate integers never introduces
// one.
export function parseRateInput(masked: string): number {
    const [wholePart = '', fractionPart = ''] = masked.replace(/,/g, '').split('.');
    const dollars = wholePart === '' ? 0 : Number.parseInt(wholePart, 10);
    const cents = Number.parseInt(fractionPart.padEnd(2, '0').slice(0, 2), 10);

    return dollars * 100 + cents;
}
